export const styles = {
  container: {
    paddingTop: '2em',
  },

  button: {
    fontSize: '1rem',
    borderRadius: '2em',
    padding: '0.5em 2em',
    textTransform: 'none',
    maxHeight: 'fit-content',
  },

  avatar: (size) => ({
    width: size === 'small' ? '2em' : '2.5em',
    height: size === 'small' ? '2em' : '2.5em',
    fontSize: '1em',
    backgroundColor: (theme) => theme.palette.baseColors.deepSeaNavy.c100,
  }),

  chip: {
    '& .MuiChip-label': {
      fontSize: (theme) => theme.fontSizes.base,
    },
  },

  search: {
    width: '100%',
    maxWidth: '1000px',
    marginBottom: '16px',

    '& .MuiOutlinedInput-root': {
      maxHeight: '50px',
      borderRadius: '8px',
      borderColor: (theme) => theme.palette.baseColors.deepSeaNavy.c25,
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: (theme) => theme.palette.baseColors.deepSeaNavy.c25,
    },
  },

  select: {
    marginBottom: '16px',

    '& .MuiOutlinedInput-root': {
      boxShadow: 'none',
    },

    '& .MuiSelect-root': {
      maxHeight: '50px',
      width: '100%',
      maxWidth: '400px',
      minWidth: '200px',
      boxShadow: 'none',
      backgroundColor: (theme) => theme.palette.baseColors.white.c100,
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
      borderColor: (theme) => theme.palette.baseColors.deepSeaNavy.c25,
    },
  },

  pagination: {
    '& .MuiSelect-root': {
      borderRadius: '8px',
      boxShadow: 'none',
      border: (theme) => `1px solid ${theme.palette.baseColors.deepSeaNavy.c25}`,
      backgroundColor: (theme) => theme.palette.baseColors.white.c100,
    },
  },
};
